import { httpsCallable } from 'firebase/functions';
import { functions } from '../../services/firebase';

export const MAX_VOICE_CAPTURE_BYTES = 20 * 1024 * 1024;
export const VOICE_FILE_ACCEPT = 'audio/m4a,audio/mp4,audio/mpeg,audio/wav,audio/webm,.m4a,.mp3,.wav,.webm';

const transcribeCareAudioCallable = httpsCallable(functions, 'transcribeCareAudio', {
  timeout: 180000,
});

export const readBlobAsBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(new Error('We could not read this audio file.'));
  reader.onload = () => resolve(String(reader.result || '').split(',')[1] || '');
  reader.readAsDataURL(blob);
});

export const transcribeVoiceCapture = async ({ childId, audioBlob, deps = {} } = {}) => {
  if (!audioBlob || audioBlob.size > MAX_VOICE_CAPTURE_BYTES) {
    throw new Error('Voice recordings must be 20 MB or smaller.');
  }
  const encode = deps.readBlobAsBase64 || readBlobAsBase64;
  const callable = deps.transcribeCareAudio || transcribeCareAudioCallable;
  const response = await callable({
    childId,
    audioBase64: await encode(audioBlob),
    mimeType: audioBlob.type || 'audio/webm',
    byteLength: audioBlob.size,
  });
  return response?.data || response;
};
